import React, {useMemo} from 'react'
import styled from 'styled-components'
import {IMAGE_ASSET} from 'consts'
import {useTranslation} from 'i18n'
import {getWhatsAppLink, getInstagramLink} from 'utils'
import {Image, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${convertUnit(12)};
`

const StyledImagesContainer = styled.div`
  display: flex;
  padding: ${convertUnit(6)};
  border-radius: 100%;
  background-color: ${({theme}) => theme.white_3};
  cursor: pointer;
`

const StyledImage = styled(Image)`
  width: ${convertUnit(24)};
  height: ${convertUnit(24)};
`

const StyledLink = styled.a`
  text-decoration: none;
`

export default function GiftShopSettingSupportHorizontal() {
  const {translate} = useTranslation()
  const whatsappImg = IMAGE_ASSET('giftshop', 'whats-app.png')
  const instagramImg = IMAGE_ASSET('giftshop', 'instagram.png')

  const handleRenderLink = useMemo(
    () => (
      <>
        <StyledLink href={getWhatsAppLink()} target="_blank">
          <StyledImagesContainer>
            <StyledImage src={whatsappImg} alt="whats-app" />
          </StyledImagesContainer>
        </StyledLink>
        <StyledLink href={getInstagramLink()} target="_blank">
          <StyledImagesContainer>
            <StyledImage src={instagramImg} alt="instagram" />
          </StyledImagesContainer>
        </StyledLink>
      </>
    ),
    [instagramImg, whatsappImg],
  )

  return (
    <StyledContainer>
      <Paragraph color="gray_5" fontWeight="medium">
        {translate('giftShop:supportTitle')}
      </Paragraph>
      {handleRenderLink}
    </StyledContainer>
  )
}
